const TOPICS_DATA = [
  {
    id: 1,
    title: '热血战斗·巅峰对决',
    desc: '汇集最燃战斗漫画，从《暗影猎手》到《剑道无双》，每一页都让人热血沸腾。',
    tag: '热血',
    img: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20illustration%2C%20two%20warriors%20clashing%20with%20energy%20bursts%2C%20warm%20orange%20and%20red%20color%20palette%2C%20Japanese%20manga%20art%20style%2C%20dynamic%20action%20composition%2C%20speed%20lines%20and%20impact%20effects%2C%20clean%20modern%20shounen%20aesthetic%2C%20vibrant%20lighting%2C%20professional%20digital%20illustration&width=600&height=400&seq=carousel-01-shounen&orientation=landscape',
    count: '3,200+ 部',
  },
  {
    id: 2,
    title: '恋爱甜宠·心动时刻',
    desc: '从校园初恋到都市爱情，甜蜜温馨的恋爱漫画让你感受每一份心动的温度。',
    tag: '恋爱',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20with%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20peach%20tones%2C%20Japanese%20shoujo%20manga%20art%20style%2C%20gentle%20spring%20atmosphere%2C%20sparkling%20light%20effects%2C%20sweet%20and%20dreamy%20composition%2C%20clean%20romantic%20illustration%2C%20delicate%20linework&width=600&height=400&seq=carousel-02-romance&orientation=landscape',
    count: '2,800+ 部',
  },
  {
    id: 3,
    title: '奇幻冒险·异世界之旅',
    desc: '穿越异世界、魔法学院、龙与地下城，最精彩的奇幻冒险故事都在这里。',
    tag: '奇幻',
    img: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20anime%20illustration%2C%20floating%20islands%20with%20crystal%20castles%2C%20teal%20and%20emerald%20green%20color%20palette%2C%20Japanese%20isekai%20manga%20style%2C%20mystical%20glowing%20runes%20and%20magic%20circles%2C%20adventurous%20atmosphere%2C%20detailed%20fantasy%20landscape%2C%20vibrant%20ethereal%20lighting&width=600&height=400&seq=carousel-03-fantasy&orientation=landscape',
    count: '2,400+ 部',
  },
  {
    id: 4,
    title: '悬疑推理·烧脑盛宴',
    desc: '密室逃脱、连环案件、心理博弈，考验智商的悬疑推理漫画让你欲罢不能。',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20anime%20scene%2C%20detective%20in%20rainy%20alley%20with%20street%20lamps%2C%20deep%20indigo%20and%20amber%20lighting%2C%20Japanese%20seinen%20manga%20art%20style%2C%20atmospheric%20shadows%20and%20silhouettes%2C%20suspenseful%20mood%2C%20detailed%20urban%20night%20setting%2C%20cinematic%20composition&width=600&height=400&seq=carousel-04-mystery&orientation=landscape',
    count: '1,600+ 部',
  },
  {
    id: 5,
    title: '搞笑日常·轻松一刻',
    desc: '沙雕日常、爆笑四格、欢乐校园，治愈系搞笑漫画让你每天开怀大笑。',
    tag: '搞笑',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20funny%20anime%20comedy%20scene%2C%20chibi%20characters%20having%20fun%20in%20school%2C%20bright%20yellow%20and%20coral%20colors%2C%20Japanese%20gag%20manga%20style%2C%20exaggerated%20expressions%20and%20reactions%2C%20playful%20and%20energetic%20atmosphere%2C%20clean%20lighthearted%20illustration%2C%20comic%20speech%20bubbles&width=600&height=400&seq=carousel-05-comedy&orientation=landscape',
    count: '2,100+ 部',
  },
  {
    id: 6,
    title: '国漫精选·原创力量',
    desc: '支持国产原创漫画，从古风玄幻到现代都市，国漫崛起之作一网打尽。',
    tag: '国漫',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%2C%20ancient%20Chinese%20warrior%20in%20flowing%20robes%20with%20sword%2C%20warm%20gold%20and%20vermilion%20tones%2C%20traditional%20ink%20wash%20painting%20aesthetic%20blended%20with%20modern%20manga%2C%20elegant%20composition%2C%20dramatic%20misty%20mountain%20background%2C%20refined%20Chinese%20art%20style&width=600&height=400&seq=carousel-06-chinese&orientation=landscape',
    count: '1,800+ 部',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            六大热门漫画专题，一站阅尽全网精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TOPICS_DATA.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold rounded-full bg-background-50/90 text-foreground-800">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 text-xs rounded-full bg-background-950/60 text-background-50">
                  {item.count}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}